var _circle, _circle2, _circle3, _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImgSuccess(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 154,
    height: 151,
    viewBox: "0 0 154 151",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 77.5,
    cy: 75.5,
    r: 70,
    stroke: "#89F3B8",
    strokeWidth: 3
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.34,
    cx: 77.5,
    cy: 75.5,
    r: 75,
    stroke: "#89F3B8"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 77.5,
    cy: 75.5,
    r: 63.5,
    stroke: "#89F3B8",
    strokeWidth: 4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 75.5C18 42.6391 44.6391 16 77.5 16C110.361 16 137 42.6391 137 75.5C137 108.361 110.361 135 77.5 135C44.6391 135 18 108.361 18 75.5Z",
    fill: "url(#paint0_linear_1535_42963)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M106.5 60C106.5 61.125 106 62.125 105.25 62.875L73.25 94.875C72.5 95.625 71.5 96 70.5 96C69.375 96 68.375 95.625 67.625 94.875L51.625 78.875C50.875 78.125 50.5 77.125 50.5 76C50.5 73.75 52.25 72 54.5 72C55.5 72 56.5 72.5 57.25 73.25L70.5 86.375L99.625 57.25C100.375 56.5 101.375 56 102.5 56C104.625 56 106.5 57.75 106.5 60Z",
    fill: "url(#paint1_linear_1535_42963)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1535_42963",
    x1: 77.5,
    y1: 16,
    x2: 77.5,
    y2: 135,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#21E375"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#20B970"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1535_42963",
    x1: 69,
    y1: 53.5,
    x2: 69,
    y2: 96,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.260076,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B3FFD4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgSuccess);
export default __webpack_public_path__ + "static/media/img_success.dcc5455a3cc0c0f4bc37b4b864c61414.svg";
export { ForwardRef as ReactComponent };